const customSpaces = {
  NAVBAR_HEIGHT: 56,
  CLASSROOM_NAVBAR_HEIGHT: 67,
  CLASSROOM_FOOTER_HEIGHT: 60,
  APP_PADDING_X: 16,
  APP_MAX_WIDTH: null,
};

const spaces = [0, 4, 8, 12, 16, 20, 24, 32, 48, 64];
const aliases = ['none', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'xxxxl'];

const spacesByAliases = aliases.reduce((result, alias, i) => {
  result[alias] = i;
  return result;
}, {});

const spacesWithUnit = spaces.map((s) => `${s}px`);

Object.keys(customSpaces).forEach((key) => {
  const value = customSpaces[key];

  spaces[key] = value;
  spacesByAliases[key] = typeof value === 'number' ? `${value}px` : value;
  spacesWithUnit[key] = typeof value === 'number' ? `${value}px` : value;
});

/**
 * https://styled-system.com/theme-specification#space
 * e.g. pb="xs"
 */
spaces.forEach((space, index) => {
  if (aliases[index]) {
    spaces[aliases[index]] = space;
  }
});

module.exports = {
  spaces,
  spacesByAliases,
  spacesWithUnit,
  customSpaces,
};

// To add more spaces later, add custom aliases to customSpaces:
// CUSTOM_SPACE = 15px
// then call it as <Box p={'CUSTOM_SPACE'} />
